import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Link, useNavigate } from "react-router-dom";
// primeReact
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Panel from "../../../components/panel/panel";
import ExportTable from "../../../components/button/ExportButton";
import ModalCreateIndex from "./ModalCreateIndex";
//services
import { getIndex } from "../../../services/GlobalRoles/getIndex";
import { onSubmitDeleteIndex } from "../../../services/Settings/Index/deleteIndex";
import { toast } from "react-toastify";
import usePermission from "../../../hooks/usePermission";
import { useAppContext } from "../../../context/AppContext";

const Index = () => {
  usePermission("149"); //Visualizar Indices de Reajuste
  const { permissions } = useAppContext();
  const items = [
    {
      template: () => (
        <Link to={`/settings/index`} className="p-breadcrumb-link">
          Índice
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const [visible, setVisible] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [headerModal, setHeaderModal] = useState("Cadastrar");
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [sendRowData, setSendRowData] = useState([]);
  const [tableToExport, setTableToExport] = useState(null);

  const columns = [{ field: "name", header: "Descrição" }];

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const handleCloseModal = () => {
    setVisible(false);
  };

  const navigate = useNavigate();

  const nextPage = (rowData) => {
    navigate("IndexInfo", { state: { rowData } });
  };

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  //delete
  function SubmitDeleteIndex(rowData) {
    setSendRowData(rowData);
    confirmDeleteIndex(rowData);
  }
  const confirmDeleteIndex = (selectedOptionDelete) => {
    var idType = selectedOptionDelete.id;
    confirmDialog({
      message: "Deseja fazer a exclusão?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: (event) => deleteIndex(event, idType),
    });
  };
  const deleteIndex = async (event, id) => {
    const notification = toast.loading("Deletando índice, aguarde...");
    setLoadingDelete(true);

    try {
      await onSubmitDeleteIndex(setLoadingDelete, setVisible, id);
      await refetch();
      setLoadingDelete(false);

      toast.update(notification, {
        render: "Índice deletado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      const errorMessage =
        error.message || "Houve um erro ao excluir os dados!";
      toast.update(notification, {
        render: errorMessage,
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
      console.error("Erro ao deletar o índice:", error);
    } finally {
      setLoadingDelete(false);
    }
  };

  const { data: index, refetch } = useQuery({
    queryKey: ["index"],
    queryFn: () => getIndex(),
    enabled: !!permissions?.includes("149"),
  });

  useEffect(() => {
    if (index) {
      // console.log(index);
      const dataWithoutIds = index.map((t) => ({
        ID: t.id,
        Indice: t.name,
        CriadoEm: t.created_at,
        AtualizadoEm: t.updated_at,
      }));
      // console.log("sem ids", dataWithoutIds);
      setTableToExport(dataWithoutIds);
    }
  }, [index]);

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-xl-4 col-md-6">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        {permissions &&
          permissions.includes("150") && ( //Cadastrar Indice de Reajuste
            <div className="col-xl-2 col-md-6">
              <Button
                rounded
                loading={loading}
                icon="fa fa-plus"
                label="Novo Índice"
                onClick={() => setVisible(true)}
                className="p-inputtext-sm me-2 m-auto w-100"
              />
            </div>
          )}
      </div>

      <Panel mainCss="mt-4" title="Índices de Reajuste">
        {!index ? (
          <Skeleton variant="rect" width="100%" height={300} />
        ) : (
          <>
            <div>
              <hr className="my-4" />
              <ExportTable
                tableData={tableToExport}
                exportColumns={exportColumns}
                onGlobalFilterChange={onGlobalFilterChange}
                globalFilterValue={globalFilterValue}
              />
              <DataTable
                stripedRows
                showGridlines
                sortMode="multiple"
                selectionMode="single"
                value={index}
                // loading={isLoadingIndex}
                paginator
                rows={5}
                sortableColumns={false}
                rowsPerPageOptions={[5, 25, 50]}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{
                  minWidth: "1rem",
                  fontSize: "0.8rem",
                  border: "0.8rem",
                }}
              >
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                  />
                ))}
                {permissions &&
                  permissions.includes("153") && ( //Informar Correções de Reajuste
                    <Column
                      header="Informar Correções"
                      body={(rowData) => (
                        <div className="text-center">
                          <button
                            disabled={loading}
                            className="btn btn-success btn-btn-sm"
                            onClick={() => nextPage(rowData)}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </button>
                        </div>
                      )}
                    />
                  )}
                {permissions &&
                  permissions.includes("152") && ( //Excluir Indice de Reajuste
                    <Column
                      header="Excluir Índice"
                      body={(rowData) => (
                        <div className="text-center">
                          <button
                            disabled={loading}
                            className="btn btn-danger btn-btn-sm"
                            onClick={() => SubmitDeleteIndex(rowData)}
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </button>
                        </div>
                      )}
                    />
                  )}
              </DataTable>
            </div>
          </>
        )}
      </Panel>

      <ModalCreateIndex
        visible={visible}
        headerModal={headerModal}
        handleCloseModal={handleCloseModal}
        setVisible={setVisible}
        refresh={refetch}
        setLoading={setLoading}
        loading={loading}
      />
    </>
  );
};

export default Index;
